import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
  import { useStore } from "vuex";
  import Modal from "@/components/ui/Modal.vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import AlertComponent from "@/components/ui/AlertComponent.vue";
  import InputFile from "@/components/ui/input/InputFile.vue";
  import { getFileFromEvent } from "@/helpers/getFileFromEvent";
  import { validateDocumentMimeType } from "@/helpers/validation";
  import { documentTypes } from "@/helpers/customer/document";
  import { alertMessages } from "@/helpers/customer/document";
  import { getUser } from "@/features/useUser";
  import { MaxFileSize } from "@/constants";
  import { validDocumentsTypes } from "@/helpers/fileUpload";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerUploaderModal',
  props: {
    isOpen: {
      type: Boolean,
      required: false,
    },
  },
  emits: ["close", "afterSuccessUpload"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const documentTypePlaceholder = {
    label: "Choose a document type",
    value: "",
  };

  const store = useStore();
  const emits = __emit;
  const props = __props;

  const activeSuccessMessage = ref("");
  const activeWarningMessage = ref("");
  const activeDocument = ref({} as File);
  const activeDocumentType = ref(documentTypePlaceholder);
  const isUploading = ref(false);
  const acceptedTypes = validDocumentsTypes.join(", ");

  const modalClasses = computed(() => {
    return `secure-document-modal height-limited${
      activeSuccessMessage.value || activeWarningMessage.value
        ? " error-block"
        : ""
    }`;
  });

  function unselectFile() {
    activeDocument.value = {} as File;
    activeWarningMessage.value = "";
  }
  function onChangeFile(event: Event) {
    activeSuccessMessage.value = "";
    const file = getFileFromEvent(event);

    if (file.size > MaxFileSize) {
      activeWarningMessage.value = alertMessages.warning[3];
    }

    if (!file) return;

    activeDocument.value = file;
    validate();
  }
  function changeDocumentType(item) {
    activeSuccessMessage.value = "";
    activeDocumentType.value = item;
    activeWarningMessage.value = "";
  }
  function onClose() {
    clearData();
    emits("close");
  }
  function clearData() {
    activeDocumentType.value = documentTypePlaceholder;
    activeDocument.value = {} as File;
    activeWarningMessage.value = "";
    activeSuccessMessage.value = "";
  }
  function onCancel() {
    clearData();
    emits("close");
  }
  function onUpload() {
    activeSuccessMessage.value = "";

    if (validate()) {
      const file = getFile();

      upload(file);
    }
  }
  function upload(file: FormData) {
    isUploading.value = true;
    store
      .dispatch("customer/uploadCustomerDocument", file)
      .then((res) => {
        clearData();
        activeSuccessMessage.value = alertMessages.success[0];
        emits("afterSuccessUpload", res.data);
      })
      .catch((error) => console.log("error", error))
      .finally(() => {
        isUploading.value = false;
      });
  }
  function getFile() {
    const file = new FormData();

    file.append("file", activeDocument.value);
    file.append("documentType", activeDocumentType.value.value);
    file.append("id", getUser().detailsId._id);
    file.append("modifiedDate", new Date());

    return file;
  }
  function validate() {
    const setErrorMessage = (index: number) => {
      activeWarningMessage.value = alertMessages.warning[index];
    };
    const isCorrectMimeType = () =>
      validateDocumentMimeType(activeDocument.value.type);
    const isSelectedDocument = () => Boolean(activeDocument.value.size);

    if (!activeDocumentType.value.value) {
      setErrorMessage(0);
      return false;
    }

    if (!isSelectedDocument()) {
      setErrorMessage(1);
      return false;
    }

    if (
      !isCorrectMimeType() &&
      !activeDocument.value.name.toLowerCase().endsWith(".heic")
    ) {
      setErrorMessage(2);
      return false;
    }

    if (activeDocument.value.size > MaxFileSize) {
      setErrorMessage(3);
      return false;
    }

    return true;
  }

const __returned__ = { documentTypePlaceholder, store, emits, props, activeSuccessMessage, activeWarningMessage, activeDocument, activeDocumentType, isUploading, acceptedTypes, modalClasses, unselectFile, onChangeFile, changeDocumentType, onClose, clearData, onCancel, onUpload, upload, getFile, validate, computed, ref, get useStore() { return useStore }, Modal, DropDown, AlertComponent, InputFile, get getFileFromEvent() { return getFileFromEvent }, get validateDocumentMimeType() { return validateDocumentMimeType }, get documentTypes() { return documentTypes }, get alertMessages() { return alertMessages }, get getUser() { return getUser }, get MaxFileSize() { return MaxFileSize }, get validDocumentsTypes() { return validDocumentsTypes } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})